import { openPopup, closePopup } from './popups'


export function initializeCookies(locoScroll){

  if (!getCookie('cookiesObj')){
    openPopup('cookies', locoScroll)
    //$('.js-cookies-popup').fadeIn()
  } else {
    cookiesObj = JSON.parse(getCookie('cookiesObj'))
    loadCookieScripts()
  }

  $('.js-accept-selected-cookies').click(function(){
    setCookie('cookiesObj', encodeURI(JSON.stringify(cookiesObj)), 365)
    closePopup($('.js-cookies-popup'), locoScroll)
    loadCookieScripts()
  })
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/; Secure";
}



let cookiesObj = {
  version: 1,
  consents: {
    'mandatory': true,
    'statistical': true,
    'simplified_login': true,
    'marketing': true
  }
}



$('.js-cookies-open-more').click(function(){
  cookiesObj.consents.statistical = false
  cookiesObj.consents.simplified_login = false
  cookiesObj.consents.marketing = false

  $('.js-cookies-options').slideDown()
  $(this).hide()
})

$('.js-cookies-option').click(function(){
  let type = $(this).data('type')

  if (!$(this).hasClass('.js-non-editable')){
    $(this).toggleClass('js-checked')
    cookiesObj['consents'][type] = !!$(this).hasClass('js-checked');
  }
})


function loadCookieScripts(){
  // Load statistical scripts
  if (cookiesObj.consents.statistical){
    let salesScriptUrl = 'https://www.seb.ee//sites//default//files//bus_apps//_adobe//1d3cb9609bd4//2109998e408a//launch-EN0de18fc42dc541afb21b73fa63b7556e.min.js'
    let myScript = document.createElement("script");
    myScript.setAttribute("src", salesScriptUrl);
    document.body.appendChild(myScript);
  }

  // Load marketing scripts
  if (cookiesObj.consents.marketing){
    let salesScriptUrl = $('.js-cookies-popup').data('salesforce-url')
    let myScript = document.createElement("script");
    myScript.setAttribute("src", salesScriptUrl);
    document.body.appendChild(myScript);
  }
}

